import React from 'react';
import './VideoSection.css'

function VirtualTour() {
    const handleMouseEnter = (event) => {
        event.target.play();
    };

    const handleMouseLeave = (event) => {
        event.target.pause();
    };

    return (
        <div className="virtual-tour-container">
            <h2>Take a virtual walk through the campus.</h2>
            <video 
                className="virtual-tour-video" 
                onMouseEnter={handleMouseEnter} 
                onMouseLeave={handleMouseLeave}
                controls
                playsInline
                muted
            >
                <source src="/external/videos/bg-video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <p>
                Explore the campus atmosphere, facilities, and daily environment before planning a visit.
            </p>
        </div>
    );
}

export default VirtualTour;
